var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"relative v-select",attrs:{"options":_vm.convertFieldsToOptions(_vm.facetFields),"multiple":"","value":_vm.filters.values,"close-on-select":false,"select-on-tab":true,"placeholder":_vm.searchablePlaceHolder,"selectable":(option) => _vm.selectableOption(option)},on:{"input":(selection) => _vm.searchableChange(selection)}})
}
var staticRenderFns = []

export { render, staticRenderFns }